import React from "react";
import Navbar from "../components/Navbar";
import Container from "../components/Container";
import Contact from "../components/contact/Contact";
import { ContactFooter } from "../components/Footer";
import image from "../assets/ResortGallery/RG8.jpg";
import TopBannerSection from "../components/TopBannerSection";
const ContactPage = () => {
    return (
      <>
        <Container>
          <Navbar />
          <TopBannerSection
            Image={image}
            pageName={"CONTACT US"}
            Quote={"Get in Touch Today"}
          />
          <Contact />
          <ContactFooter />
        </Container>
      </>
    );
};

export default ContactPage;
